import { render } from "./ChiusureGiornaliereAdminView.vue?vue&type=template&id=1e8f8e7b&scoped=true"
import script from "./ChiusureGiornaliereAdminView.vue?vue&type=script&lang=js"
export * from "./ChiusureGiornaliereAdminView.vue?vue&type=script&lang=js"

import "./ChiusureGiornaliereAdminView.vue?vue&type=style&index=0&id=1e8f8e7b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e8f8e7b"]])

export default __exports__